import { isEqual, isNil } from 'lodash';
import { isDateString } from '@shared/util/date';
import { i18n } from '@shared/util/i18n';
import { EditableField, Field } from './Field';

interface DateRangeInput {
  start: MBAPI.Scalar.DateTime | null;
  end: MBAPI.Scalar.DateTime | null;
}

export class DateRangeField implements EditableField {
  readonly dateRange: DateRangeInput;
  readonly fieldType = 'DateRangeField';

  public constructor(dateRange: DateRangeInput) {
    this.dateRange = dateRange;
  }

  validate(): string | null {
    // if either date is defined but not a valid date, return an error
    if (!isNil(this.dateRange.start) && !isDateString(this.dateRange.start)) {
      return i18n('workflowTemplate.component.error.dateRange.invalid');
    }
    if (!isNil(this.dateRange.end) && !isDateString(this.dateRange.end)) {
      return i18n('workflowTemplate.component.error.dateRange.invalid');
    }
    // if both dates are not defined, return null
    if (isNil(this.dateRange.start) || isNil(this.dateRange.end)) {
      return null;
    }
    // if the start date is after the end date, return an error
    if (this.dateRange.start > this.dateRange.end) {
      return i18n('workflowTemplate.component.error.dateRange.endMustBeAfterStart');
    }
    return null;
  }

  isEqual(field: Field): boolean {
    return field instanceof DateRangeField && isEqual(this.dateRange, field.dateRange);
  }

  toFieldJson() {
    return this.dateRange;
  }

  get isEmpty() {
    return isNil(this.dateRange.start) && isNil(this.dateRange.end);
  }

  static fromFieldJson(jsonBlob: MBAPI.Scalar.JSON): DateRangeField | null {
    if (isDateString(jsonBlob?.start) || isDateString(jsonBlob?.end)) {
      return new DateRangeField({
        start: jsonBlob.start ?? null,
        end: jsonBlob.end ?? null,
      });
    } else {
      return null;
    }
  }
}
